import React, { useState } from 'react'
import styled from 'styled-components'

import { AnimateHeight } from '@root/shared/ui-kit'
import { WalletsDialog } from '@root/widgets/desktop/wallets-dialog'
import { WalletSelectorDrawer } from '@root/widgets/wallet'

import { PaymentWalletsInput } from './payment-wallets-input'

import type { PaymentSourceWallet } from '../atoms'
import type { DeviceType } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  required?: boolean
  label?: React.ReactNode
  topLabel?: string
  disabled?: boolean
  errorMessage?: string
  paymentSource?: PaymentSourceWallet
  device: DeviceType
  setPaymentSource?: (paymentSource: PaymentSourceWallet) => void
} & ClassNameProps

export const PaymentWallets: React.FC<Props> = ({
  label,
  paymentSource,
  device,
  disabled,
  required,
  topLabel,
  errorMessage,
  setPaymentSource,
  className,
}) => {
  const [walletDialogOpen, setWalletDialogOpen] = useState(false)

  return (
    <Root data-disabled={!!disabled} className={className}>
      {topLabel ? (
        <Caption>
          {topLabel}
          {required ? <Required>*</Required> : undefined}
        </Caption>
      ) : undefined}
      <Wallets>
        {label ? <Title>{label}</Title> : undefined}

        <PaymentWalletsInput
          paymentSource={paymentSource}
          setWalletDialogOpen={setWalletDialogOpen}
        />
      </Wallets>
      <AnimateHeight>
        {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : undefined}
      </AnimateHeight>
      {device === 'mobile' ? (
        <WalletSelectorDrawer
          open={walletDialogOpen}
          onOpenChange={setWalletDialogOpen}
          onWalletClick={(wallet) => {
            setPaymentSource?.({ type: 'internal-wallet', wallet: wallet })
            setWalletDialogOpen(false)
          }}
        />
      ) : (
        <WalletsDialog
          open={walletDialogOpen}
          onOpenChange={setWalletDialogOpen}
          selectedWalletId={paymentSource?.wallet.id}
          onWalletSelected={(wallet) => {
            setPaymentSource?.({ type: 'internal-wallet', wallet: wallet })
            setWalletDialogOpen(false)
          }}
        />
      )}
    </Root>
  )
}

const Root = styled.div``
const Required = styled.span`
  color: var(--error-9);
  font-weight: 600;
  font-size: 14px;
`

const Caption = styled.div`
  font-size: 12px;
  color: var(--text-11);
  margin-bottom: 8px;
`

const Title = styled.h3`
  color: var(--text-12);
  text-align: left;

  font-size: 12px;
  font-weight: 600;
  line-height: normal;
`

const Wallets = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  transition: all 0.1s ease-in-out;
`
const ErrorMessage = styled.div`
  color: var(--red-9);

  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
`
